<template>
	<div>
		<notifications />
        <preloader v-if="isLoading"></preloader>
		<template-form
			title="Add Service"
			submitTxt="Save Service"
			:fields="fields"
			:errors="fieldErrors"
			:isLoading="isLoading"
			:onSubmit="handleSubmit"
			:basePrice="basePrice"
			:onSubserviceUpdate="updateSubservices">
		</template-form>
	</div>
</template>

<script>
import Form from './Form.vue';
import { defaultFields, getBasePrice } from "./helpers";
import Preloader from "../Preloader.vue";

export default {
	components: {
		'template-form': Form, Preloader
	},
	data() {
		return {
			isLoading: false,
			fields: defaultFields(),
			fieldErrors: defaultFields(),
			basePrice: 0,
		}
	},
	async beforeMount() {
		this.isLoading = true;
		this.basePrice = await getBasePrice();
		this.fields.price = this.basePrice;
		this.isLoading = false;
	},
	methods: {
		handleSubmit(fields) {
			this.isLoading = true;

			return axios.post('/services', fields).then(response => {
				this.fields = {
					...defaultFields(),
					price: this.basePrice,
				};
				
				this.$notify({
					type: 'success',
					title: 'Service added',
					text: 'You\'ve successfully saved the service!'
				})
			}).catch(error => {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}).finally(() => {
				this.isLoading = false;
			});
		},
		updateSubservices(newList) {
			this.fields.subservices = newList;
		}
	}
}
</script>
